<template lang="html">
	<div class="component lightproperties">
		<div class="script-name">
			<div style="padding: 4px;display: inline-block;"><i class="icon-lightbulb"></i> <span>Light</span></div>
			<button type="button" class="btn-icon btn-delete" title="Remove Script" @click="$emit('remove')" style="float: right;font-size: inherit;margin: 0;"><i class="icon-delete"></i></button>
		</div>
		<div class="script-properties">
			<select v-model="modelValue.type" @change="changeType()">
				<option v-for="type in types" :key="type">{{type}}</option>
			</select>

			<div style="font-size: 14px;padding: 8px 0;">
				<label>Position</label>
				<div style="display: flex;">
					<div v-for="(label, variable) in {x: 'X', y: 'Y'}" :key="variable" class="input-group" :style="variable === 'x' ? 'margin-right: 7px;' : ''">
						<input type="text" :value="modelValue.position[variable]" @change="modelValue.position[variable] = parseFloat($event.target.value.replace(/[^0-9.\-]/g, '') || 0);change()">
						<span class="input-group-append">{{label}}</span>
					</div>
				</div>
			</div>

			<div v-for="(val, name) in modelValue.params" :key="name" class="input-group" v-if="modelValue.params" style="margin-top: 10px;">
				<input type="text" v-model="modelValue.params[name]" @input="change()">
				<span class="input-group-append">{{name}}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['modelValue'],
	emits: ['update:modelValue', 'remove'],
	data: function () {
		return {
			types: ['Point', 'Spot', 'Area']
		};
	},
	methods: {
		change() {
			this.$emit('update:modelValue', this.modelValue);
		},
		changeType: function () {
			switch (this.modelValue.type) {
				case 'Point':
					this.modelValue.params = {
						r1: 10,
						r2: 100,
						density: 0.8
					};
					break;
				case 'Spot':
					this.modelValue.params = null;
					break;
				case 'Area':
					this.modelValue.params = {
						width: 600,
						height: 400
					};
					break;
			}
			this.change();
		}
	}
}
</script>
